/**
 * localStorage 浏览器缓存,页面关闭就清空
 */
const storage = {

  // 设置缓存
  set(key: string, val: any) {
    localStorage.setItem(key, JSON.stringify(val));
  },

  // 获取缓存
  get(key: string) {
    const json: any = localStorage.getItem(key);
    return json === null ? '' : JSON.parse(json);
  },

  // 移除缓存
  remove(key: string) {
    localStorage.removeItem(key);
  },

  // 移除全部缓存
  clear() {
    localStorage.clear();
  }
}

export default storage;
